/**
 * LES FAMILLES DE PERSONNEL (RQ, 01/10/2026) — préparateurs (accueil et
 * prélèvement), techniciens, biologistes, support ; dans chacune, l'ordre
 * alphabétique. La famille se lit sur la FONCTION déclarée (`fonctionIds`),
 * jamais sur le poste tenu : un salarié tient des postes de plusieurs blocs
 * dans le même mois, il n'a qu'une fonction.
 */
export const FAMILLES_PERSONNEL: { cle: string; titre: string; fonctions: string[] }[] = [
  { cle: 'prep', titre: 'Préparateurs — accueil et prélèvement', fonctions: ['f_preleveur', 'f_secretaire', 'f_preparateur'] },
  { cle: 'tech', titre: 'Techniciens', fonctions: ['f_technicien'] },
  { cle: 'bio', titre: 'Biologistes', fonctions: ['f_biologiste'] },
  { cle: 'support', titre: 'Support', fonctions: [] },
];

export const familleDe = (p: { fonctionIds?: unknown[] | null }) =>
  FAMILLES_PERSONNEL.find((f) => f.fonctions.length && (p.fonctionIds || []).some((x) => f.fonctions.includes(String(x))))?.cle || 'support';

/** L'ordre alphabétique ignore le titre (« Dr ») : sinon les biologistes
 *  titrés passent tous devant, quel que soit leur nom. */
export const sansTitre = (n: string) => n.replace(/^(Dr|Pr|Mme|M)\.?\s+/i, '');
